import BaseStimulusModelController from "../../../BaseStimulusModelController";
import { SearchStimulusModel } from "../../../../scripts/_generated/SearchStimulusModel";
import { configureTypeaheadAutocomplete } from "../../../../scripts/typeaheadHelper";
import { SearchResultItem } from "../../../../scripts/_generated/SearchResultItem";
import { stringFormat } from "../../../../scripts/helpers";
import * as Turbo from "@hotwired/turbo";
import './Search.scss';
import { SearchResultType } from "../../../../scripts/_generated/SearchResultType";

export const destinationSelectedEventName = "destinationSelected";
export const noDestinationsFoundEventName = "noDestinationsFound";

export default class SearchController extends BaseStimulusModelController<SearchStimulusModel> {
    static targets = [
        "searchInput"
    ];

    readonly searchInputTargets!: HTMLElement[]; // collection needed - typeahead creates another input

    connect() {
        this.configureDestinationSearch();
    }

    private configureDestinationSearch() {
        configureTypeaheadAutocomplete(
            this.modelValue.searchUrl,
            $(this.searchInputTargets),
            undefined,
            (searchResultItem: SearchResultItem) => `${searchResultItem.name}`,
            "name",
            "$searchedTerm",
            () => {
                this.dispatch(noDestinationsFoundEventName);                
            },  
            {
                suggestion: (searchResultItem: SearchResultItem) => {
                    const fontAwesomeElement = searchResultItem.type === SearchResultType.Destination 
                    ? "" 
                    : `<span class="${searchResultItem.iconCode}"></span>`;
                    return `<div class="tt-suggestion tt-selectable">
    ${fontAwesomeElement}
    <a href="${searchResultItem.url}">${searchResultItem.name}</a>
</div>`;
                }

            }
        );

        $(this.searchInputTargets).on('typeahead:select', (_, searchResultItem: SearchResultItem) => {
            Turbo.visit(searchResultItem.url);
        });
    }
}

